var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmexCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 30.7647,
    rx: 3.5,
    fill: "#1F72CD",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06674 11.25L3.85645 20.8413H8.89676L9.52161 19.312H10.9499L11.5747 20.8413H17.1227V19.6741L17.6171 20.8413H20.4869L20.9813 19.6494V20.8413H32.5195L33.9225 19.3517L35.2362 20.8413L41.1625 20.8536L36.9389 16.0724L41.1625 11.25H35.3281L33.9624 12.712L32.6901 11.25H20.1379L19.0601 13.7256L17.957 11.25H12.9272V12.3775L12.3676 11.25H8.06674ZM9.04201 12.612H11.4989L14.2916 19.1159V12.612H16.983L19.14 17.2752L21.128 12.612H23.806V19.4944H22.1765L22.1632 14.1014L19.7875 19.4944H18.3299L15.941 14.1014V19.4944H12.5887L11.9532 17.9514H8.51975L7.88554 19.493H6.08946L9.04201 12.612ZM31.9226 12.612H25.2968V19.4903H31.82L33.9225 17.2107L35.9491 19.4903H38.0675L34.9884 16.0711L38.0675 12.612H36.041L33.9491 14.8654L31.9226 12.612ZM10.2372 13.7764L9.10601 16.5251H11.3671L10.2372 13.7764ZM26.933 15.2933V14.037V14.0358H31.0673L32.8713 16.045L30.9874 18.0653H26.933V16.6937H30.5477V15.2933H26.933Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexCard);
export default __webpack_public_path__ + "static/media/amexCard.f6be79ac.svg";
export { ForwardRef as ReactComponent };